import React from 'react';

const BO = ({ className }: { className?: string }) => (
  <svg
    className={className}
    width="21"
    height="15"
    viewBox="0 0 21 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <mask
      id="mask0_3_191"
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="21"
      height="15"
    >
      <path
        d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask0_3_191)">
      <path
        d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
        fill="#FFE200"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9 7H10V8H9V7ZM11 7H12V8H11V7Z"
        fill="#009BBE"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 7H13V9H12V7ZM11 6H12V7H11V6ZM9 6H10V7H9V6ZM8 7H9V9H8V7Z"
        fill="#D7280F"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10 8H11V9H10V8Z"
        fill="#007B30"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10 6H11V7H10V6Z"
        fill="#3F291F"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11 8H12V9H11V8ZM9 8H10V9H9V8Z"
        fill="#EAA400"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10 7H11V8H10V7Z"
        fill="#3B5B27"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 10H21V15H0V10Z"
        fill="#007A30"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 0H21V5H0V0Z"
        fill="#D7280F"
      />
      <path
        d="M19 0.5H2C1.17157 0.5 0.5 1.17157 0.5 2V13C0.5 13.8284 1.17157 14.5 2 14.5H19C19.8284 14.5 20.5 13.8284 20.5 13V2C20.5 1.17157 19.8284 0.5 19 0.5Z"
        stroke="black"
        strokeOpacity="0.1"
      />
    </g>
  </svg>
);

export default BO;
